import { createReducer } from '../../utils';
import types from './types';

export const initialState = {
    isFeedbackDialogOpen: false,
    isChatButtonShown: false,
    footer: null
};

const ACTION_HANDLERS = {
    [types.OPEN_FEEDBACK_DIALOG]: state => ({
        ...state,
        isFeedbackDialogOpen: true
    }),
    [types.CLOSE_FEEDBACK_DIALOG]: state => ({
        ...state,
        isFeedbackDialogOpen: false
    }),
    [types.SHOW_CHAT_BUTTON]: state => ({
        ...state,
        isChatButtonShown: true
    }),
    [types.HIDE_CHAT_BUTTON]: state => ({
        ...state,
        isChatButtonShown: false
    }),
    [types.FETCH_FOOTER.SUCCESS]: (state, { payload: { footer } }) => ({
        ...state,
        footer,
    })
};

export default createReducer(ACTION_HANDLERS, initialState);
